import { RecurringTransactionOptions } from '../../Utils/api/DropdownfilterApi';
import React, { 
    useState, 
    useEffect  
  } from 'react'
  
  import Navbar from '../../Components/Navbar/Navbar'
  import toast from 'react-hot-toast';

  import { 
      Layout,
      Col, 
      Row,
      Button,
      Space,
      Modal,
      Form,
      Input,
      Table,
    //   Menu,
    //   Dropdown,
      Select,
      InputNumber,
  } from 'antd';
  import { 
    ProductOutlined,
    // ExclamationCircleFilled 
  } from '@ant-design/icons';
//   import { MoreVert  } from '@mui/icons-material';
  import { UseGetRequest } from '../../Utils/api/ApiRequests' 
  import { usePostRequest } from '../../hooks/usePostRequest'
  import { 
    // useNavigate, 
    useLocation 
} from "react-router-dom"
import BtnExcel from '../../Components/BtnExcel';
import { formatAmount, getTodayDateISO } from '../../Utils/Common';
  
const { Item } = Form;
// const { confirm } = Modal;
const { Search } = Input;
const { Option } = Select;
  
const RecurringTransaction = () => {
    // const navigate = useNavigate();
    const location = useLocation();
    const [recurringForm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [recurringModal, setRecurringModal] = useState(false);
    const [recurringData, setRecurringData] = useState([]);
    const [memberData, setMemberData] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
      member_id: '',
      term: '',
    });

    const typeData = RecurringTransactionOptions().map((option) => ({
        name: option.label,
        value: option.value,
        amount: 0,
    }));

    // Keep legacy saved types readable without changing their stored values.
    const getTypeLabel = (type) => typeData.find((option) => option.value === type)?.name
        || ({ monthly_due: 'Monthly Due', golf_cart: 'Golf Cart' }[type])
        || type;

    const { callPost, loading } = usePostRequest(()=>{
        recurringForm.resetFields();
        setRecurringModal(false);
        fetchRecurringData();
    });
  
    const customSpinner = <ProductOutlined style={{ fontSize: 24, color: "#005E30"  }} spin />;

    const columns = [
        {
            title: 'Member Name',
            dataIndex: 'member_name',
            key: 'member_name',
            align: 'center',
            sorter: (a, b) => a.member_name.localeCompare(b.member_name),
        },
        {
            title: 'AR Customer ID',
            dataIndex: 'ar_cust_id',
            key: 'ar_cust_id',
            align: 'center',
            sorter: (a, b) => a.ar_cust_id.localeCompare(b.ar_cust_id),
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            align: 'center',
            render: getTypeLabel,
            sorter: (a, b) => a.type.localeCompare(b.type),
        
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            sorter: (a, b) => a.amount.localeCompare(b.amount),
        
        },
        {
            title: 'Added By',
            dataIndex: 'added_by_user',
            key: 'added_by_user',
            align: 'center',
        },
        {
            title: 'Updated By',
            dataIndex: 'updated_by_user',
            key: 'updated_by_user',
            align: 'center',
        },
        // {
        //     title: '',
        //     dataIndex: 'actions',
        //     key: 'actions',
        //     align: 'center',
        //     width: '5%',
        //     render: (_, record) => (
        //         <ActionBtn row={record} />
        //     ),
        // },
    ];

    // function ActionBtn(row) {
    //     const menu = (
    //         <Menu>
                
    //             <Menu.Item 
    //                 key="delete"
    //                 style={{color: 'red'}}
    //                 onClick={() => showDeleteConfirm(row.row.id)}
    //             >
    //                 Delete
    //             </Menu.Item>
                 
    //         </Menu>
    //     );

    //     return (
    //         <>
    //             <span className='center'>
    //                 <Dropdown
    //                     overlay={menu} 
    //                     placement="bottomLeft"
    //                     trigger={['click']}
    //                 >
    //                 <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
    //                     <Space>
    //                     <MoreVert />
    //                     </Space>
    //                 </div>
    //                 </Dropdown>
    //             </span>
    //         </>
    //     );
    // };

    // const showDeleteConfirm = (id) => {
    //     var finalValues = Object.entries({recurring_transaction_id: id}).map(([key, value]) => ({
    //         key,
    //         value,
    //     }));

    //     confirm({
    //       title: 'Do you want to permanently remove this Transaction?',
    //       icon: <ExclamationCircleFilled className='red-cont'/>,
    //       content: 'This action cannot be undone.',
    //       okText: 'Yes',
    //       okType: 'danger',
    //       cancelText: 'No',
    //       width: 600,
    //       loading: {loading},
    //       okButtonProps: {
    //         className: 'cancel-antbtn',
    //         loading: loading,
    //       },
    //       cancelButtonProps: {
    //         className: 'save-antbtn',
    //       },
    //       confirmLoading: loading,
          
    //       onOk() {
    //         callPost(
    //             `recurring_transactions/delete`, 
    //             finalValues,
    //             true
    //         );
    //       },
    //     });
    // };
  
    async function fetchRecurringData() {
      setIsLoading(true);
      const response = await UseGetRequest("recurring_transactions/get_recurring_transaction", filterConfig);
      if (response?.data) {
        setRecurringData(response?.data?.recurring_transactions);
        const excel_data = response?.data?.recurring_transactions?.map((data) => ({
            member_name: data.member_name,
            ar_cust_id: data.ar_cust_id,
            type: getTypeLabel(data.type),
            amount: formatAmount(data.amount),
            added_by_user: data.added_by_user,
            updated_by_user: data.updated_by_user,
        }));
        setExcelData(excel_data);
      } else {
        setRecurringData([]);
        setExcelData([]);
      }
      setIsLoading(false);
    }

    async function fetchMemberData(search) {
      setIsLoading(true);
      const response = await UseGetRequest("members/get_all", {cust_term: search});
      if (response?.data) {
        const member_data = response?.data?.members.map((data) => ({
            ...data,
            full_name: data.last_name + ", " + data.first_name + " " + data.middle_name
        }))
        setMemberData(member_data);
      } else {
        setMemberData([]);
      }
      setIsLoading(false);
    }

    const handleAddRecurring = () => {
        recurringForm.validateFields().then(values => {
            const newValues = {
                ar_cust_id: values.ar_cust_id || ' ',
                type: values.type || ' ',
                amount: values.amount || ' ',
            }

            callPost(
                "recurring_transactions/generate", 
                newValues,
                false,
            );
        }).catch(errorInfo => { 
          toast.error('Validation Failed ', errorInfo);
        });
    };

    const handleTableChange = (pagination) => {
      setFilterConfig((prev) => ({
        ...prev,
        page: parseInt(pagination.current),
        page_size: pagination.pageSize,
      }));
    };

    const handleChange = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            term: e || '',
            page: 1,
          }
        ));
    };
      
    const handleEmpty = (e) => {
        if(e.target.value === ''){
          setFilterConfig((prev) => (
            {
              ...prev,
              term: e.target.value || '',
              page: 1,
            }
          ));
        }
    };

    const handleArCustId = (member_id) => {
        const all_member = memberData.filter((item) => item.ar_cust_id === member_id);
    
        recurringForm.setFieldsValue({
            member_name: all_member[0]?.full_name,
        });
    };

    const handleType = (value) => {
        const all_member = typeData.filter((item) => item.value === value);
    
        recurringForm.setFieldsValue({
            amount: all_member[0]?.amount,
        });
    };
    
    useEffect(() => {
        if (!recurringModal) {
          window.history.replaceState({}, document.title, location.pathname);          
          setRecurringModal(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recurringModal]);
      
    useEffect(() => {
        fetchRecurringData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);
    
    return (
        <Layout className='page'>
            <Navbar navKey={'credit_recurring'}/>
            <Layout className='content-container overflow-y'>
                <Row className='custom-padding responsive-tab-inline'>
                    <Col span={15} className='header-container'>
                        RECURRING TRANSACTION
                    </Col>
                    <Col span={9} className='mt-2 responsive-tab-width' align='end'>
                        <Space className='responsive-inline'> 
                            <Search
                                placeholder="Search Transaction"
                                size='medium'
                                onSearch={(e)=>handleChange(e)}
                                onChange={(e)=>handleEmpty(e)}
                                className='responsive-header-input'
                            />  
                            <BtnExcel
                                label={"Export to Excel"}
                                size={"sm"}
                                excelData={excelData}
                                xlsxHeaders={[
                                    "Member Name",
                                    "AR Customer ID",
                                    "Type",
                                    "Amount",
                                    "Added By",
                                    "Updated By",
                                ]}
                                handleData={fetchRecurringData}
                                isClicked={isLoading}
                                fileName={`Recurring_Transaction_${getTodayDateISO()}.xlsx`}
                            />        
                            <Button 
                                className='button-color responsive-header-btn' 
                                onClick={() => setRecurringModal(true)} 
                                type="primary"
                            >
                                + Generate
                            </Button>         
                        </Space>
                    </Col>
                </Row>
                <Row className='page-content'>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Table 
                            columns={columns} 
                            dataSource={recurringData} 
                            loading={{
                            indicator: customSpinner,
                            spinning: isLoading,
                            }}
                            pagination={{
                            defaultPageSize: 10,
                            //   total: pageSize,
                            current: filterConfig?.page,
                            pageSize: filterConfig?.total_records_per_page,
                            }}
                            onChange={handleTableChange}
                        />
                    </Col>
                </Row>
                <Modal
                    title="Generate Recurring Transaction"
                    open={recurringModal}
                    onOk={handleAddRecurring}
                    onCancel={() => {
                        setRecurringModal(false);
                        recurringForm.resetFields();
                    }}
                    okText="Save"
                    maskClosable={false}
                    width={800} 
                    loading={loading}
                >
                    <Form 
                        form={recurringForm} 
                        layout="vertical"
                    >
                        <Row>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="AR Cust ID"
                                    name="ar_cust_id"
                                    rules={[{ required: true, message: 'Please select a AR Cust ID' }]}

                                >
                                    <Select 
                                        placeholder="Search Ar Cust ID" 
                                        showSearch
                                        // filterOption={(input, option) =>
                                        //     option?.children?.toLowerCase().includes(input.toLowerCase())
                                        // }
                                        onChange={(e) => handleArCustId(e)}
                                        onSearch={(e) =>
                                            {
                                                if (e.length >= 3) {
                                                    fetchMemberData(e);
                                                }
                                            }
                                        }
                                    >
                                        {memberData.map((option) => (
                                            <Option key={option.ar_cust_id} value={option.ar_cust_id}>{option.ar_cust_id}</Option>
                                        ))}
                                    </Select>
                                </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Member Name"
                                    name="member_name"
                                    rules={[{ required: true, message: 'Please select a Member Name' }]}
                                >
                                    <Input
                                        disabled
                                    />
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                        <Col span={12} className='p-2'>
                                <Item
                                    label="Type"
                                    name="type"
                                    rules={[{ required: true, message: 'Please select a Type' }]}

                                >
                                    <Select 
                                        placeholder="Select a Type" 
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                        onChange={(e) => handleType(e)}
                                    >
                                        {typeData.map((option) => (
                                            <Option key={option.value} value={option.value}>{option.name}</Option>
                                        ))}
                                    </Select>
                                </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Amount"
                                    name="amount"
                                >
                                    <InputNumber
                                        style={{width:'100%'}}
                                    />
                                </Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </Layout>
        </Layout>
    )
  }
  
  export default RecurringTransaction
  